var _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIconFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#0866FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.4,
    height: 26.4,
    transform: "translate(11.8047 12)",
    fill: "#0866FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1749 26.5426L30.9157 22.5087H26.604V21.082C26.604 18.9505 27.4404 18.1305 29.6046 18.1305C30.2768 18.1305 30.818 18.1469 31.1295 18.1796V14.5232C30.5392 14.359 29.0962 14.1953 28.2598 14.1953C23.8489 14.1953 21.8156 16.2777 21.8156 20.7705V22.5087H19.0938V26.5426H21.8156V35.3201C22.8367 35.5735 23.9049 35.7087 25.0042 35.7087C25.5454 35.7087 26.0792 35.6754 26.6035 35.612V26.5426H30.1744H30.1749Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconFilled);
export default __webpack_public_path__ + "static/media/facebookIconFilled.d52a193c3763bc87eebabef8290c53ae.svg";
export { ForwardRef as ReactComponent };